import React, { useState, useEffect } from "react";
import { Box, Tab, Tabs } from "@curves/ui-base";
import { MeasurementDateController, REPORT_MEASUREMENT_LAYOUT, ReportFocusModeToggleButton } from "@Local/Measurement/Components/Common";
import { MeasurementResultsPage, MeasurementTranscriptPage, MeasurementEvaluationPage } from "@Local/Measurement/";
import { MEASUREMENT_REPORT_TABS } from "@Constants";
import { useMeasurementContext } from "@Local/Measurement/Context/MeasurementContext";

const MeasurementReportPage = () => {
	const { setMeasureID, reportFocusMode, setReportFocusMode } = useMeasurementContext();
	const [activeTab, setActiveTab] = useState(MEASUREMENT_REPORT_TABS.RESULT);

	useEffect(
		() => () => {
			setReportFocusMode(false);
		},
		[setReportFocusMode],
	);

	const tabPageProps = {
		reportLayout: reportFocusMode ? REPORT_MEASUREMENT_LAYOUT.FOCUS : REPORT_MEASUREMENT_LAYOUT.DEFAULT,
	};

	const tabContent = (
		<>
			{activeTab === MEASUREMENT_REPORT_TABS.RESULT && <MeasurementResultsPage {...tabPageProps} />}
			{activeTab === MEASUREMENT_REPORT_TABS.EVALUATION && <MeasurementEvaluationPage {...tabPageProps} />}
			{activeTab === MEASUREMENT_REPORT_TABS.TRANSCRIPT && <MeasurementTranscriptPage {...tabPageProps} />}
		</>
	);

	const reportToolbar = (
		<Box className={`measurement-report-toolbar${reportFocusMode ? " measurement-report-toolbar--focus" : ""}`}>
			{!reportFocusMode && (
				<Box className={"measurement-report-toolbar__date"}>
					<MeasurementDateController setMeasureID={setMeasureID} />
				</Box>
			)}
			<ReportFocusModeToggleButton focusMode={reportFocusMode} onToggle={() => setReportFocusMode(prev => !prev)} />
		</Box>
	);

	if (reportFocusMode) {
		return (
			<Box className={"measurement-report-focus"}>
				{reportToolbar}
				<Box className={"measurement-report-focus__content"}>{tabContent}</Box>
			</Box>
		);
	}

	return (
		<Box className={"container mb-5"}>
			{reportToolbar}
			<Box className={"measurement-menu"}>
				<Tabs value={activeTab} onChange={(e, v) => setActiveTab(v)} className={"measurement-menu--container"}>
					<Tab label={"量身結果"} value={MEASUREMENT_REPORT_TABS.RESULT} />
					<Tab label={"身體評估"} value={MEASUREMENT_REPORT_TABS.EVALUATION} />
					<Tab label={"成績單"} value={MEASUREMENT_REPORT_TABS.TRANSCRIPT} />
				</Tabs>
			</Box>
			<Box>{tabContent}</Box>
		</Box>
	);
};

export default MeasurementReportPage;
